import { Box, Text } from "@chakra-ui/layout";
import { Modal } from "antd";
import { useCriarEditarVeiculo } from "core/features/veiculo/hooks/useCriarEditarVeiculo";
import { useDetalhesVeiculo } from "core/features/veiculo/hooks/useDetalhesVeiculo";
import { useListarTiposVeiculo } from "core/features/veiculo/hooks/useListarTiposVeiculo";
import { VeiculoForm } from "core/features/veiculo/typings";
import { showErrorAxios, useLoading } from "infra/helpers/alerta";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FooterModal from "ui/components/Button/FooterModal";
import FormVeiculo from "./FormVeiculo";

interface ModalCadastroPetProps {
  isOpen: boolean;
  unidadeId: string;
  onClose: () => any;
  onSaved: any;
  id?: string;
}

function ModalCadastroPet({
  isOpen,
  unidadeId,
  id,
  onClose,
  onSaved,
}: ModalCadastroPetProps) {
  const [registerAnother, setRegisterAnother] = useState(false);

  const { data: veiculo, isLoading: isLoadingDetalhesAnimal } =
    useDetalhesVeiculo(id);

  const { data: tiposVeiculo, isLoading: isLoadingTiposVeiculo } =
    useListarTiposVeiculo();

  const { mutate: handleSave, isLoading } = useCriarEditarVeiculo();

  const handleModalSubmit = async (data: VeiculoForm) => {
    handleSave(
      { ...data, unidadeId },
      {
        onSuccess: () => {
          setTimeout(() => {
            onSaved();

            if (!registerAnother) {
              onClose();
            } else {
              reset({});
            }
          }, 200);
        },
        onError: (err) => {
          showErrorAxios(err);
        },
      }
    );
  };

  const { control, handleSubmit, watch, formState, reset } =
    useForm<VeiculoForm>({
      reValidateMode: "onChange",
      mode: "onTouched",
    });

  useLoading(isLoading || isLoadingDetalhesAnimal || isLoadingTiposVeiculo);

  useEffect(() => {
    if (!isOpen) {
      reset({});
    }
  }, [isOpen, reset]);

  useEffect(() => {
    if (veiculo) {
      const form = {
        ...veiculo,
      };

      reset({ ...form });
    }
  }, [veiculo, reset]);

  return (
    <Modal
      destroyOnClose
      width="800px"
      footer={
        <FooterModal
          registerAnother={registerAnother}
          setRegisterAnother={setRegisterAnother}
          onSubmit={handleSubmit(handleModalSubmit)}
          onClose={onClose}
          isLoadingSave={isLoading}
          isDisabled={!formState.isValid}
        />
      }
      centered
      bodyStyle={{
        height: "max(80vh, 400px)",
        overflow: "auto",
        paddingBottom: 16,
      }}
      visible={isOpen}
      onCancel={onClose}
    >
      <Box pt={4} pb={6}>
        <form onSubmit={(ev) => handleSubmit(handleModalSubmit)(ev)}>
          <>
            <Text as="h3" fontSize={20}>
              {veiculo?.id ? "Editar" : "Cadastrar"} veículo
            </Text>

            <Box pt="16px">
              <FormVeiculo
                control={control}
                watch={watch}
                tiposVeiculo={tiposVeiculo}
              />
            </Box>
          </>
        </form>
      </Box>
    </Modal>
  );
}

export default ModalCadastroPet;
